import React from 'react'
import { AmpImg } from '../../../content/Picture/Image.amp'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'
import { StyledDiv, StyledSpan } from './AmpFlourish.Styled'

export interface AmpFlourishProps {
    link: string
}

export const processEmbedLink = (link: string) => {
    const ampParam = 'embed?auto=1'
    if (link[link.length - 1] !== '/') {
        return `${link}/${ampParam}`
    }
    return `${link}${ampParam}`
}

export const AmpFlourish: React.FC<AmpFlourishProps> = (props) => (
    <StyledContent>
        <StyledDiv>
            <AmpImg
                layout={'fixed'}
                height={16}
                width={16}
                src={'https://public.flourish.studio/favicon.ico'}
                alt={'Flourish'}
            ></AmpImg>
            <StyledSpan>Flourish</StyledSpan>
        </StyledDiv>
        <AmpIFrame
            width={797} // Set to create an Aspect ratio, the layout = responsive will resize
            height={500} // Set to create an Aspect ratio, the layout = responsive will resize
            src={processEmbedLink(props.link)}
            frameborder={0}
            layout={'responsive'}
            allowSameOrigin={true}
            allowPopups={true}
            allowForms={false}
            resizable={true}
            noFallback={true}
        />
    </StyledContent>
)
